import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const SPECIALDEAL_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SpecialDeal.Name')
    .required()
    .minLength(1)
    .maxLength(200)
    .build(),
];

export const SPECIALDEAL_CONFIG = {
  entityName: 'SpecialDeal',
  localizationKey: 'Controlling::Entity.SpecialDeal',
  fields: SPECIALDEAL_FIELDS,
  permission: 'ControllingContract.SpecialDeals',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
